import * as React from 'react';

import {Button} from 'shells/button/button';
import {ErrorMessage} from 'shells/form/error-message';
import {StackLegacy} from 'shells/layout/stack/stack-legacy';
import {TextField} from 'shells/textfield/textfield';

import {regenerateMfa} from '../../../auth/utils';

import {MfaHeader, MfaBody} from '../typography/index';

type Props = {
    goNext: () => void;
    handlePhoneNumber: (arg1: string) => void;
    prefilledPhoneNumber?: string;
};

export function VerifySmsPhoneScreen(props: Props) {
    const [isSendingText, setIsSendingText] = React.useState<boolean>(false);
    const [codeIsInvalid, setCodeIsInvalid] = React.useState<string>('');
    const [phoneNumber, setPhoneNumber] = React.useState<string>(
        props.prefilledPhoneNumber !== undefined ? props.prefilledPhoneNumber : ''
    );

    const sendText = () => {
        if (phoneNumber !== '') {
            setIsSendingText(true);
            regenerateMfa({mfaType: '1', userData: phoneNumber})
                .then((result) => {
                    setIsSendingText(false);
                    if (!result.isValid) {
                        throw new Error(result.messages);
                    }

                    props.handlePhoneNumber(result.phoneNumber);
                    props.goNext();
                })
                .catch(() => {
                    setCodeIsInvalid('Invalid phone number');
                    setIsSendingText(false);
                });
        } else {
            setCodeIsInvalid('Phone number must not be blank');
        }
    };

    return (
        <StackLegacy spacing={12}>
            <MfaHeader>Step 1: Enter your phone number</MfaHeader>
            <MfaBody>We’ll text you a code</MfaBody>

            <TextField
                id='phone'
                // @ts-expect-error
                name='phone'
                size='big'
                placeholder='+1 888-336-8808'
                type='phone'
                value={phoneNumber}
                onEnter={sendText}
                onChange={(value) => {
                    setPhoneNumber(value);
                }}
            />
            <Button
                variant='primary'
                size='xlarge'
                disabled={isSendingText}
                isFullWidth={true}
                onClick={sendText}
            >
                {isSendingText ? 'Sending…' : 'Send text'}
            </Button>

            {codeIsInvalid !== '' ? <ErrorMessage>{codeIsInvalid}</ErrorMessage> : undefined}
        </StackLegacy>
    );
}
